/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InquiryDto } from '../../models/inquiry-dto';

export interface InquiryControllerFindAllV1$Params {
}

export function inquiryControllerFindAllV1(http: HttpClient, rootUrl: string, params?: InquiryControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<InquiryDto>>> {
  const rb = new RequestBuilder(rootUrl, inquiryControllerFindAllV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<InquiryDto>>;
    })
  );
}

inquiryControllerFindAllV1.PATH = '/api/v1/inquiry';
